{
  "Années-lumière": "سنوات ضوئية",
  "Bonds de renard": "قفزات الثعلب",
  "Cascade": "الشلال",
  "Cascade continue": "الشلال المتواصل",
  "Cavalcade": "الخبب",
  "Chambre d’écho": "غرفة الصدى",
  "Chaîne des éléments": "سلسلة العناصر",
  "Comète": "المذنّب",
  "Coup d’épaule": "ضربة الكتف",
  "Couvée nombreuse": "الحضنة الكبيرة",
  "Danse avec ses drapeaux et enchaîne les éléments sur la mesure : feu, eau, air, terre.": "يرقص بأعلامه ويسلسل العناصر مع كل مقطع: نار، ماء، هواء، تراب.",
  "Deux lucioles de plus volent avec toi.": "يراعتان إضافيتان تطيران معك.",
  "Deux poussins de plus marchent dans ta bande.": "كتكوتان إضافيان يمشيان في سربك.",
  "Dragon jumeau": "التنين التوأم",
  "Dub des champignons": "دَب الفطر",
  "Débandade": "التدافع",
  "Déchaîné": "الهائج",
  "Démesure": "بلا حدود",
  "Elle brûle qui n'est pas à l'ombre.": "تحرق كل من ليس في الظل.",
  "Emprise": "السطوة",
  "Encore !": "مرة أخرى!",
  "Encre fraîche": "حبر طازج",
  "Entre chien et loup": "الشفق",
  "Fosse illuminée": "الصفوف الأمامية المضيئة",
  "Frappe de mule": "الركلة الصاروخية",
  "Frappe enroulée": "الركلة الملتفّة",
  "Frappe son ballon de bad vibe en bad vibe, et court pour frapper plus fort.": "يركل كرته من bad vibe إلى أخرى، ويركض ليركل بقوة أكبر.",
  "Grand halo": "الهالة الكبرى",
  "Grand motif": "النقش الكبير",
  "Grand rappel": "الإعادة الكبرى",
  "Grande cascade": "الشلال الكبير",
  "Grands astres": "الأجرام الكبرى",
  "Half-time": "Half-time",
  "Hibou": "البومة",
  "Il noie les pièges sous ses flaques.": "تُغرق الفخاخ تحت بِركها.",
  "Il siffle, et n'encaisse les coups qu'une mesure sur deux.": "يصفر، ولا يتلقى الضربات إلا مقطعًا من كل اثنين.",
  "L'Orage": "العاصفة",
  "La Canicule": "موجة الحر",
  "La cérémonie": "المراسم",
  "Laisse ses étoiles au sol et les relie en constellations qui piègent les bad vibes et renforcent les tirs de l’équipe.": "يترك نجومه على الأرض ويربطها في كوكبات تحاصر الـbad vibes وتقوّي طلقات الفريق.",
  "Lance ses trois massues et court les ramasser, en rythme.": "يرمي هراواته الثلاث ويركض لالتقاطها، على الإيقاع.",
  "Lancer d’épaule": "رمية الكتف",
  "Lanterne grande ouverte": "الفانوس المفتوح على مصراعيه",
  "Lanterne ouverte": "الفانوس المفتوح",
  "Lanterne pleine": "الفانوس الممتلئ",
  "Lanterne vite rouverte": "الفانوس السريع الفتح",
  "Le Faux contact": "السلك المرتخي",
  "Le Larsen": "الصفير",
  "Le festival a tenu": "صمد المهرجان",
  "Les Moustiques": "البعوض",
  "Les ailes de bois": "الأجنحة الخشبية",
  "Les quatre marches": "الدرجات الأربع",
  "Les scènes du festival": "مسارح المهرجان",
  "Lucioles vagabondes": "اليراعات الهائمة",
  "Là où tu vises, l’éclipse frappe, ralentit et éclate en rayons de soleil, puis ton horloge bascule.": "حيث تصوّب، يضرب الكسوف ويُبطئ وينفجر أشعةَ شمس، ثم تنقلب ساعتك.",
  "Lâche des dragons d’encre qui traversent toute la foule.": "يطلق تنانين من حبر تخترق الحشد كله.",
  "L’ombre de ton éclipse couvre bien plus large.": "يغطي ظلّ كسوفك مساحة أوسع بكثير.",
  "L’ombre de ton éclipse couvre deux fois plus large.": "يغطي ظلّ كسوفك ضعف المساحة.",
  "L’ombre de ton éclipse couvre plus large.": "يغطي ظلّ كسوفك مساحة أوسع.",
  "L’élément du moment où tu la lances se déchaîne en feu, en vague, en tornade ou en faille.": "ينطلق العنصر السائد لحظة إطلاقها هائجًا: نارًا أو موجة أو إعصارًا أو صدعًا.",
  "Main sûre": "يد ثابتة",
  "Mandala de feu": "ماندالا النار",
  "Massues": "الهراوات",
  "Massues lestées": "هراوات مثقّلة",
  "Motif": "النقش",
  "Nuit de chasse": "ليلة الصيد",
  "Perséides": "البرشاويات",
  "Petit creux": "جوع خفيف",
  "Plante devant la scène des bâtons lumineux qui pulsent sur le temps, et les fait tous éclater d’un rappel.": "يغرس أمام المسرح عصيًّا مضيئة تنبض على الإيقاع، ثم يفجّرها كلها بإعادة.",
  "Plein air": "في الهواء الطلق",
  "Plein ciel": "سماء عامرة",
  "Pluie de météores": "زخّة الشهب",
  "Prend racine sans bouger, et son renard bondit de bad vibe en bad vibe.": "يتجذّر دون أن يتحرك، وثعلبه يقفز من bad vibe إلى أخرى.",
  "Racines": "الجذور",
  "Racines profondes": "جذور عميقة",
  "Rappel": "الإعادة",
  "Rayon et croissants ensemble 1,5 mesure après ta bascule.": "الشعاع والأهلّة معًا لمقطع ونصف بعد انقلاب ساعتك.",
  "Rayon et croissants ensemble 2 mesures après ta bascule.": "الشعاع والأهلّة معًا لمقطعين بعد انقلاب ساعتك.",
  "Rayon et croissants ensemble une mesure après ta bascule.": "الشعاع والأهلّة معًا لمقطع واحد بعد انقلاب ساعتك.",
  "Rayonnement": "الإشعاع",
  "Remontés à bloc": "مشحونون بالكامل",
  "Reprends tes pièges, puis entre dans une sortie. Elle se prend après deux mesures.": "استرجع فخاخك، ثم ادخل أحد المخارج. يُعتمد بعد مقطعين.",
  "Reprenez vos pièges, puis retrouvez-vous tous dans la même sortie. Elle se prend après deux mesures.": "استرجعوا فخاخكم، ثم اجتمعوا كلكم في المخرج نفسه. يُعتمد بعد مقطعين.",
  "Route de la soie": "طريق الحرير",
  "Récupération": "الاستعادة",
  "Réinjection": "التغذية الراجعة",
  "Sa bande de poussins le suit en file, et file picorer les bad vibes.": "يتبعه سرب كتاكيته في طابور، ثم ينطلق لينقر الـbad vibes.",
  "Scène {stage} sur {total}": "المسرح {stage} من {total}",
  "Serres": "المخالب",
  "Ses lucioles filent piquer les bad vibes et reviennent, plus nombreuses la nuit.": "تنطلق يراعاته لتلسع الـbad vibes ثم تعود، وتكثر ليلًا.",
  "Ses notes repartent en échos comme un delay de dub, et rien ne le ralentit.": "تعود نغماته أصداءً مثل delay في موسيقى الـdub، ولا شيء يبطئه.",
  "Sous la coupole": "تحت القبّة",
  "Sous la voile": "تحت الشراع",
  "Sprint final": "العدو الأخير",
  "Ta cascade frappe deux fois plus fort.": "يضرب شلالك بقوة مضاعفة.",
  "Ta cascade frappe plus fort.": "يضرب شلالك بقوة أكبر.",
  "Ta cascade frappe trois fois plus fort.": "يضرب شلالك بثلاثة أضعاف القوة.",
  "Ta cascade revient bien plus vite.": "يعود شلالك أسرع بكثير.",
  "Ta cascade revient plus vite.": "يعود شلالك أسرع.",
  "Ta cascade revient presque en continu.": "يعود شلالك دون توقف تقريبًا.",
  "Ta débandade piétine deux fois plus fort.": "يدوس تدافعك بقوة مضاعفة.",
  "Ta débandade piétine plus fort.": "يدوس تدافعك بقوة أكبر.",
  "Ta débandade piétine trois fois plus fort.": "يدوس تدافعك بثلاثة أضعاف القوة.",
  "Ta débandade revient bien plus vite.": "يعود تدافعك أسرع بكثير.",
  "Ta débandade revient plus vite.": "يعود تدافعك أسرع.",
  "Ta débandade revient presque aussitôt.": "يعود تدافعك على الفور تقريبًا.",
  "Ta spéciale dure bien plus longtemps.": "تدوم مهارتك الخاصة أطول بكثير.",
  "Ta spéciale dure deux fois plus longtemps.": "تدوم مهارتك الخاصة ضعف المدة.",
  "Ta spéciale dure plus longtemps.": "تدوم مهارتك الخاصة أطول.",
  "Ta spéciale déchaîne aussi les deux éléments suivants.": "تُطلق مهارتك الخاصة أيضًا العنصرين التاليين.",
  "Ta spéciale déchaîne aussi l’élément suivant.": "تُطلق مهارتك الخاصة أيضًا العنصر التالي.",
  "Ta spéciale déchaîne les quatre éléments à la fois.": "تُطلق مهارتك الخاصة العناصر الأربعة دفعة واحدة.",
  "Ta spéciale déchaîne ses éléments en bien plus grand.": "تُطلق مهارتك الخاصة عناصرها أكبر بكثير.",
  "Ta spéciale déchaîne ses éléments en démesure.": "تُطلق مهارتك الخاصة عناصرها بلا حدود.",
  "Ta spéciale déchaîne ses éléments en plus grand.": "تُطلق مهارتك الخاصة عناصرها أكبر.",
  "Ta spéciale fond deux fois plus fort.": "تنقضّ مهارتك الخاصة بقوة مضاعفة.",
  "Ta spéciale fond nettement plus fort.": "تنقضّ مهارتك الخاصة بقوة أكبر بوضوح.",
  "Ta spéciale fond plus fort.": "تنقضّ مهارتك الخاصة بقوة أكبر.",
  "Ta spéciale libère deux lucioles de plus.": "تُطلق مهارتك الخاصة يراعتين إضافيتين.",
  "Ta spéciale libère quatre lucioles de plus.": "تُطلق مهارتك الخاصة أربع يراعات إضافية.",
  "Ta spéciale libère six lucioles de plus.": "تُطلق مهارتك الخاصة ست يراعات إضافية.",
  "Ta spéciale s’étend moitié plus loin autour de toi.": "تمتد مهارتك الخاصة أبعد بمقدار النصف من حولك.",
  "Ta spéciale s’étend nettement plus loin autour de toi.": "تمتد مهارتك الخاصة أبعد بكثير من حولك.",
  "Ta spéciale s’étend plus loin autour de toi.": "تمتد مهارتك الخاصة أبعد من حولك.",
  "Ta spéciale éclate nettement plus large et plus fort.": "تنفجر مهارتك الخاصة أوسع وأقوى بكثير.",
  "Ta spéciale éclate plus large et plus fort.": "تنفجر مهارتك الخاصة أوسع وأقوى.",
  "Ta spéciale éclate presque deux fois plus large, et fort.": "تنفجر مهارتك الخاصة أوسع بمرتين تقريبًا، وبقوة.",
  "Temps suspendu": "الزمن المعلّق",
  "Tes bâtons lumineux frappent moitié plus large.": "تضرب عصيّك المضيئة أوسع بمقدار النصف.",
  "Tes bâtons lumineux frappent nettement plus large.": "تضرب عصيّك المضيئة أوسع بكثير.",
  "Tes bâtons lumineux frappent plus large.": "تضرب عصيّك المضيئة أوسع.",
  "Tes dragons filent deux fois plus vite et plus loin.": "تنطلق تنانينك بضعف السرعة والمسافة.",
  "Tes dragons filent nettement plus vite et plus loin.": "تنطلق تنانينك أسرع وأبعد بكثير.",
  "Tes dragons filent plus vite et plus loin.": "تنطلق تنانينك أسرع وأبعد.",
  "Tes lucioles piquent deux bad vibes de plus en chemin.": "تلسع يراعاتك اثنتين إضافيتين من الـbad vibes في طريقها.",
  "Tes lucioles piquent trois bad vibes de plus en chemin.": "تلسع يراعاتك ثلاثًا إضافية من الـbad vibes في طريقها.",
  "Tes lucioles piquent une bad vibe de plus en chemin.": "تلسع يراعاتك bad vibe إضافية في طريقها.",
  "Tes massues traversent deux bad vibes de plus.": "تخترق هراواتك اثنتين إضافيتين من الـbad vibes.",
  "Tes massues traversent trois bad vibes de plus.": "تخترق هراواتك ثلاثًا إضافية من الـbad vibes.",
  "Tes massues traversent une bad vibe de plus.": "تخترق هراواتك واحدة إضافية من الـbad vibes.",
  "Tes massues volent deux fois plus vite et plus loin.": "تطير هراواتك بضعف السرعة والمسافة.",
  "Tes massues volent nettement plus vite et plus loin.": "تطير هراواتك أسرع وأبعد بكثير.",
  "Tes massues volent plus vite et plus loin.": "تطير هراواتك أسرع وأبعد.",
  "Tes notes ont deux échos de plus.": "لنغماتك صديان إضافيان.",
  "Tes notes ont trois échos de plus.": "لنغماتك ثلاثة أصداء إضافية.",
  "Tes notes ont un écho de plus.": "لنغماتك صدى إضافي.",
  "Tes poussins donnent deux coups de bec de plus.": "تنقر كتاكيتك نقرتين إضافيتين.",
  "Tes poussins donnent trois coups de bec de plus.": "تنقر كتاكيتك ثلاث نقرات إضافية.",
  "Tes poussins donnent un coup de bec de plus.": "تنقر كتاكيتك نقرة إضافية.",
  "Tes racines poussent bien plus vite.": "تنمو جذورك أسرع بكثير.",
  "Tes racines poussent deux fois plus vite.": "تنمو جذورك أسرع بمرتين.",
  "Tes racines poussent plus vite.": "تنمو جذورك أسرع.",
  "Tes échos frappent moitié plus fort.": "تضرب أصداؤك أقوى بمقدار النصف.",
  "Tes échos frappent nettement plus fort.": "تضرب أصداؤك بقوة أكبر بكثير.",
  "Tes échos frappent plus fort.": "تضرب أصداؤك بقوة أكبر.",
  "Tes éléments tiennent deux temps de plus.": "تصمد عناصرك نبضتين إضافيتين.",
  "Tes éléments tiennent trois temps de plus.": "تصمد عناصرك ثلاث نبضات إضافية.",
  "Tes éléments tiennent un temps de plus.": "تصمد عناصرك نبضة إضافية.",
  "Tes étoiles se relient de moitié plus loin.": "تترابط نجومك من مسافة أبعد بمقدار النصف.",
  "Tes étoiles se relient de nettement plus loin.": "تترابط نجومك من مسافة أبعد بكثير.",
  "Tes étoiles se relient de plus loin.": "تترابط نجومك من مسافة أبعد.",
  "Ton ballon fait deux rebonds de plus.": "ترتد كرتك مرتين إضافيتين.",
  "Ton ballon fait trois rebonds de plus.": "ترتد كرتك ثلاث مرات إضافية.",
  "Ton ballon fait un rebond de plus.": "ترتد كرتك مرة إضافية.",
  "Ton ballon file deux fois plus vite et plus loin.": "تنطلق كرتك بضعف السرعة والمسافة.",
  "Ton ballon file nettement plus vite et plus loin.": "تنطلق كرتك أسرع وأبعد بكثير.",
  "Ton ballon file plus vite et plus loin.": "تنطلق كرتك أسرع وأبعد.",
  "Ton dermographe lâche deux dragons de plus à chaque temps.": "تطلق آلة وشمك تنينين إضافيين مع كل نبضة.",
  "Ton dermographe lâche trois dragons de plus à chaque temps.": "تطلق آلة وشمك ثلاثة تنانين إضافية مع كل نبضة.",
  "Ton dermographe lâche un dragon de plus à chaque temps.": "تطلق آلة وشمك تنينًا إضافيًا مع كل نبضة.",
  "Ton mandala revient bien plus vite.": "تعود الماندالا أسرع بكثير.",
  "Ton mandala revient plus vite.": "تعود الماندالا أسرع.",
  "Ton mandala revient presque aussitôt.": "تعود الماندالا على الفور تقريبًا.",
  "Ton mandala s’élargit et frappe plus fort.": "تتّسع الماندالا وتضرب بقوة أكبر.",
  "Ton mandala s’élargit nettement et frappe plus fort.": "تتّسع الماندالا بوضوح وتضرب بقوة أكبر.",
  "Ton mandala s’étend presque au double et frappe fort.": "تتّسع الماندالا إلى الضعف تقريبًا وتضرب بقوة.",
  "Ton portail lâche deux météores de plus, un par temps.": "تُسقط بوابتك نيزكين إضافيين، واحدًا مع كل نبضة.",
  "Ton portail lâche quatre météores de plus, un par temps.": "تُسقط بوابتك أربعة نيازك إضافية، واحدًا مع كل نبضة.",
  "Ton portail lâche trois météores de plus, un par temps.": "تُسقط بوابتك ثلاثة نيازك إضافية، واحدًا مع كل نبضة.",
  "Ton rayon devient immense et tes croissants énormes.": "يصير شعاعك هائلًا وأهلّتك ضخمة.",
  "Ton rayon s’élargit bien et tes croissants grossissent bien.": "يتّسع شعاعك كثيرًا وتكبر أهلّتك كثيرًا.",
  "Ton rayon s’élargit et tes croissants grossissent.": "يتّسع شعاعك وتكبر أهلّتك.",
  "Ton renard fait deux sauts de plus.": "يقفز ثعلبك قفزتين إضافيتين.",
  "Ton renard fait trois sauts de plus.": "يقفز ثعلبك ثلاث قفزات إضافية.",
  "Ton renard fait un saut de plus.": "يقفز ثعلبك قفزة إضافية.",
  "Ton sprint final renverse deux fois plus fort.": "يُسقط عدوك الأخير بقوة مضاعفة.",
  "Ton sprint final renverse plus fort.": "يُسقط عدوك الأخير بقوة أكبر.",
  "Ton sprint final renverse trois fois plus fort.": "يُسقط عدوك الأخير بثلاثة أضعاف القوة.",
  "Ton sprint final revient bien plus vite.": "يعود عدوك الأخير أسرع بكثير.",
  "Ton sprint final revient plus vite.": "يعود عدوك الأخير أسرع.",
  "Ton sprint final revient presque aussitôt.": "يعود عدوك الأخير على الفور تقريبًا.",
  "Ton élément touche aussi les bad vibes autour, plus loin.": "يصيب عنصرك أيضًا الـbad vibes من حوله، أبعد.",
  "Ton élément touche aussi les bad vibes juste autour.": "يصيب عنصرك أيضًا الـbad vibes القريبة منه مباشرة.",
  "Ton élément touche aussi les bad vibes, bien plus loin.": "يصيب عنصرك أيضًا الـbad vibes، أبعد بكثير.",
  "Tous tes bâtons lumineux éclatent d’un coup, puis se rallument.": "تنفجر كل عصيّك المضيئة دفعة واحدة، ثم تعود لتضيء.",
  "Tout ralentit autour de toi, sauf tes échos, qui se répètent une fois de plus.": "يتباطأ كل شيء من حولك إلا أصداءك، فتتكرر مرة إضافية.",
  "Toute ta bande charge d’un coup là où tu vises et renverse ce qu’elle piétine.": "يندفع سربك كله دفعة واحدة حيث تصوّب ويُسقط كل ما يدوسه.",
  "Toutes les scènes, tous les sunrises : le sound system a tenu le festival entier.": "كل المسارح وكل شروق: صمد الـsound system طوال المهرجان.",
  "Toutes tes massues partent d’un coup, rebondissent de bad vibe en bad vibe et te reviennent.": "تنطلق كل هراواتك دفعة واحدة، ترتد من bad vibe إلى أخرى ثم تعود إليك.",
  "Trois lucioles de plus volent avec toi.": "ثلاث يراعات إضافية تطير معك.",
  "Trois poussins de plus marchent dans ta bande.": "ثلاثة كتاكيت إضافية تمشي في سربك.",
  "Tu gagnes deux rayons le jour et deux croissants la nuit.": "تكسب شعاعين في النهار وهلالين في الليل.",
  "Tu gagnes trois rayons le jour, trois croissants la nuit.": "تكسب ثلاثة أشعة في النهار، وثلاثة أهلّة في الليل.",
  "Tu gagnes un rayon le jour et un croissant la nuit.": "تكسب شعاعًا في النهار وهلالًا في الليل.",
  "Tu gardes deux étoiles de plus au sol.": "تُبقي نجمتين إضافيتين على الأرض.",
  "Tu gardes trois étoiles de plus au sol.": "تُبقي ثلاث نجوم إضافية على الأرض.",
  "Tu gardes une étoile de plus au sol.": "تُبقي نجمة إضافية على الأرض.",
  "Tu ouvres ta lanterne et une nuée de lucioles pique les bad vibes devant toi, plus encore la nuit.": "تفتح فانوسك فيلسع سربٌ من اليراعات الـbad vibes أمامك، وأكثر ليلًا.",
  "Tu ouvres un portail là où tu vises, d’où tombent en rythme les météores d’une autre galaxie.": "تفتح بوابة حيث تصوّب، تتساقط منها على الإيقاع نيازك من مجرّة أخرى.",
  "Tu plantes deux bâtons lumineux de plus à la fois.": "تغرس عصوين مضيئتين إضافيتين في كل مرة.",
  "Tu plantes quatre bâtons lumineux de plus à la fois.": "تغرس أربع عصيّ مضيئة إضافية في كل مرة.",
  "Tu plantes six bâtons lumineux de plus à la fois.": "تغرس ست عصيّ مضيئة إضافية في كل مرة.",
  "Tu sprintes, l’Élan à fond, et renverses toutes les bad vibes que tu traverses.": "تعدو والزخم في أقصاه، وتُسقط كل الـbad vibes التي تعبرها.",
  "Tu traces devant toi un mandala qui frappe en rythme les bad vibes qui marchent dessus.": "ترسم أمامك ماندالا تضرب على الإيقاع الـbad vibes التي تمشي فوقها.",
  "Un hibou plane au-dessus de toi et fond sur les bad vibes, qu’il fige sur place.": "بومة تحلّق فوقك وتنقضّ على الـbad vibes فتجمّدها في مكانها.",
  "Un poussin de plus marche dans ta bande.": "كتكوت إضافي يمشي في سربك.",
  "Un rayon de soleil le jour, des croissants de lune la nuit : son horloge bascule toutes les quatre mesures.": "شعاع شمس في النهار، وأهلّة في الليل: تنقلب ساعته كل أربعة مقاطع.",
  "Une luciole de plus vole avec toi.": "يراعة إضافية تطير معك.",
  "Une prise qui grésille, et coupe le son une mesure sur quatre.": "قابس يطقطق، ويقطع الصوت مقطعًا من كل أربعة.",
  "Une tête de moustique et sa nuée, qui pique et revient gorgée.": "رأس بعوضة وسربها، يلسع ويعود متخمًا.",
  "Vers": "نحو",
  "Voie lactée": "درب التبانة",
  "la musique s’est arrêtée": "توقفت الموسيقى",
  "tenue": "صمد",
  "{count} boss en plus": {
    "zero": "لا زعماء إضافيين",
    "one": "زعيم إضافي واحد",
    "two": "زعيمان إضافيان",
    "few": "{count} زعماء إضافيين",
    "many": "{count} زعيمًا إضافيًا",
    "other": "{count} زعيم إضافي"
  },
  "{count} scènes tenues, puis la musique s’est arrêtée sur {stage}.": {
    "zero": "لم يصمد أي مسرح، وتوقفت الموسيقى على {stage}.",
    "one": "صمد مسرح واحد، ثم توقفت الموسيقى على {stage}.",
    "two": "صمد مسرحان، ثم توقفت الموسيقى على {stage}.",
    "few": "صمدت {count} مسارح، ثم توقفت الموسيقى على {stage}.",
    "many": "صمد {count} مسرحًا، ثم توقفت الموسيقى على {stage}.",
    "other": "صمد {count} مسرح، ثم توقفت الموسيقى على {stage}."
  },
  "{percent} % de vie et de coups en plus pour les bad vibes": "{percent}% صحة وضرر إضافيان للـbad vibes",
  "{stage} a tenu": "صمد {stage}",
  "{time} de marche": "{time} سيرًا",
  "Éclipse": "الكسوف",
  "Éclipse totale": "الكسوف الكلي",
  "Élan": "الزخم",
  "≈ {minutes} min · {bpm} BPM": "≈ {minutes} د · {bpm} BPM"
}
